export default {
  root: {
    fontSize: 0
  }
}
